import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppEventService, PumpSetSvgService, UtilsService } from 'pumpcalc-core';

@Component({
  selector: 'app-diagram',
  templateUrl: './diagram.component.html',
  styleUrls: ['./diagram.component.css']
})
export class DiagramComponent implements OnInit, OnChanges {

  pumpSet;

  constructor(public pumpSetSvgService:PumpSetSvgService, private utilsService:UtilsService, private appEventService:AppEventService) {
    appEventService.events.subscribe(event=>{      
      if(event.name=="CHANGE" && (event.context=="pumpset" || event.context=="backingPump")){this.pumpSet=this.utilsService.clone(event.data);}
      if(event.name=="VIEW" && event.context=="Pumpset"){        
        this.pumpSet=this.utilsService.clone(event.data);}
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
  }

}

